import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { H3 } from "BaseComponents/Text";

export const CircleBackground = styled.div.attrs(
  ({ theme, bottomLine, index }) => ({
    borderColor: theme.colors.primary,
    bottomLine: bottomLine ?? false,
    index: index,
  })
)`
	background-image: url('data:image/svg+xml;utf8,<svg id="circle" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="2" fill="${({
    borderColor,
  }) => borderColor}"/></svg>');
  background-position: right;
  background-size: 4px 17px;
  background-repeat: repeat-y;	
  ${media.lessThan(breakpoints.mobile)`		
		background-position: bottom;
		background-size: 13px 4px;
		background-repeat: repeat-x;	
	`}

	${media.lessThan(breakpoints.mobileLess)`			
			&:last-child {
				background-image: none;
			}	
	`}

  ${media.greaterThan(breakpoints.mobile)`
	${({ bottomLine, index }) =>
    bottomLine
      ? css`
          height: 100%;
          ${(index === 1 || index === 0) &&
          css`
            background-position: bottom;
            background-size: 13px 4px;
            background-repeat: repeat-x;
          `};
          ${(index === 2 || index === 3) &&
          css`
            background-image: none;
          `};
        `
      : css`
          flex-basis: calc(50% - 2px);
          flex-grow: 1;
          ${index % 2 === 0
            ? css`
                background-position: right;
                background-size: 4px 17px;
                background-repeat: repeat-y;
              `
            : css`
                background-image: none;
              `};
        `}
		
	`}

  ${media.greaterThan(breakpoints.ipadPlus)`   
		${({ bottomLine, borderColor }) =>
      bottomLine
        ? css`
            background-image: none;
          `
        : css`
            background-image: url('data:image/svg+xml;utf8,<svg id="circle" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="2" fill="${borderColor}"/></svg>');
            background-position: right;
            background-size: 4px 17px;
            background-repeat: repeat-y;

            &:last-child {
              background-image: none;
            }
          `}
  `}
	
}`;

export const ServiceCardWrapper = styled(CircleBackground).attrs(
  ({ theme, centerContent, removePadding }) => ({
    borderColor: theme.colors.primary,
    centerContent: centerContent,
    removePadding: removePadding,
  })
)`
  border: none;
  padding: 0rem 2.75rem 1.25rem 2.75rem;
  display: flex;
  flex-direction: column;
  width: auto;
  align-items: ${({ centerContent }) =>
    centerContent ? "center;" : "flex-start;"};
  outline: none;
  transition: all 0.2s ease;
  min-height: 220px;
  width: 100%;

  ${H3} {
    border-bottom: 2px solid transparent;
    transition: 0.2s ease;
  }

  ${media.lessThan(breakpoints.mobile)`
		padding: 1.75rem 1rem;
		flex-basis: 100;
		flex-grow: 1;	
	`}

  ${media.greaterThan(breakpoints.mobile)`
		padding: 0 1rem;
		flex-basis: calc(50% - 2px);
		flex-grow: 1;
		${({ index }) =>
      (index === 1 || index === 0) &&
      css`
        padding-bottom: 2rem;
        padding-top: 0rem;
      `};
	${({ index }) =>
    (index === 2 || index === 3) &&
    css`
      padding-bottom: 0rem;
      padding-top: 2rem;
    `};
		
	`}

  ${media.greaterThan(breakpoints.ipadPlus)`
    flex: 1;
		&:first-of-type {
			margin-left: 0;
		}
		${({ index }) =>
      (index === 1 || index === 0) &&
      css`
        padding: 0rem 2.75rem 1.25rem 2.75rem;
      `};
		${({ index }) =>
      (index === 2 || index === 3) &&
      css`
        padding: 0rem 2.75rem 1.25rem 2.75rem;
      `};
  `}
    
  &:hover, &:focus {
    ${H3} {
      transition: 0.2s ease;
    }
  }
  ${({ removePadding }) =>
    removePadding &&
    css`
      padding: 0 !important;
    `}
`;
